import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funktionsbereiche-checklisten';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenFunktionsbereicheChecklistenEffects {

    FunktionsbereicheChecklisten$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKTIONSBEREICHE_CHECKLISTEN),
        mergeMap((x: ac.GetFunktionsbereicheChecklistenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunktionsbereicheChecklisten(x.typAdminCanShow).pipe(
                map((result: any) => {
                    return new ac.GetFunktionsbereicheChecklistenErfolgreichAction(result, x.typAdminCanShow, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunktionsbereicheChecklistenFehlerAction(error, x.typAdminCanShow, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VorlagenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VorlagenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VorlagenQueryService);
        }
        return this.service;
    }
}
